/* Cobra Coldres — leitura da CONFIGURAÇÃO escolhida na página de produto.

   Extraído de cobra-whatsapp-comprar.js em 2026-08-19, quando o chat do site passou a
   precisar da mesma informação. Fica num arquivo só de propósito: as duas sutilezas aqui
   (o <variant-selects> fantasma do Dawn e as opções ocultas) já custaram caro uma vez e
   não podem divergir entre os canais.

   Expõe window.cobraVarianteConfig() -> [{ nome: 'Mão', valor: 'Destro' }, ...] */
(function () {
  /* variant-selects "vivo": o Dawn mantém o antigo por ~500ms (display:none) após trocar */
  function liveVS() {
    var todos = document.querySelectorAll('variant-selects');
    for (var i = 0; i < todos.length; i++) {
      if (todos[i].style.display !== 'none') return todos[i];
    }
    return todos[0] || null;
  }

  /* uma entrada por opção; ignora opções ocultas (ex.: red dot em revólver) */
  window.cobraVarianteConfig = function () {
    var vs = liveVS();
    if (!vs) return [];
    var itens = [];
    vs.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
      var fs = r.closest('fieldset, .product-form__input');
      if (fs && fs.classList.contains('cobra-opcao-oculta')) return;
      /* .trim() ANTES do corte do sufixo: o Dawn escreve name="Mão-1\n" com quebra de
         linha, e em JavaScript o "$" nao casa antes do \n final (ao contrario de outras
         linguagens). Sem o trim, o sufixo "-1" ficava e a mensagem saia "Mão-1: Destro".
         Bug antigo do "Comprar pelo WhatsApp", encontrado em 19/08 ao montar o chat. */
      itens.push({ nome: r.name.trim().replace(/-\d+$/, ''), valor: r.value });
    });
    if (!itens.length) {
      vs.querySelectorAll('select').forEach(function (s) {
        var fs = s.closest('.product-form__input');
        if (fs && fs.classList.contains('cobra-opcao-oculta')) return;
        var m = s.name.match(/options\[(.+)\]/);
        if (s.value) itens.push({ nome: m ? m[1].trim() : '', valor: s.value });
      });
    }
    return itens;
  };
})();
